<div class="plausi-container">
	<!-- Zeile 1: Projekt-Zuordnung -->
	@if (isAssignedToActiveProject() && canAssignToProject) {
		<div class="alert alert-info d-flex align-items-center gap-2 mb-2 py-2">
			<i class="bi bi-link-45deg"></i>
			<span class="flex-grow-1">Punkt ist dem aktiven Projekt zugeordnet.</span>
			<button class="btn btn-sm btn-outline-danger" (click)="removeFromProject()">
				<i class="bi bi-x-circle me-1"></i>Zuordnung entfernen
			</button>
		</div>
	}
	@else if (canAssignToProject) {
		<div class="alert alert-warning d-flex align-items-center gap-2 mb-2">
			<i class="bi bi-exclamation-triangle-fill"></i>
			<span class="flex-grow-1">Punkt ist nicht dem aktiven Projekt zugeordnet.</span>
			<button class="btn btn-sm btn-primary" (click)="assignToProject()">
				<i class="bi bi-link-45deg me-1"></i>Jetzt zuordnen
			</button>
		</div>
	}

	<!-- Zeile 2: Letzte Bearbeitung -->
	@if (bp.lastModified) {
		<div class="info-row mb-2">
			<i class="bi bi-clock-history"></i>
			<span>Zuletzt bearbeitet: {{ formatLastModified(bp.lastModified) }}</span>
		</div>
	}

	<!-- Zeile 3: Import-Info -->
	@if (bp.importInfo) {
		<div class="info-row mb-3">
			<i class="bi bi-box-arrow-in-down"></i>
			<span>
				Importiert am {{ formatImportTime(bp.importInfo.time) }}
				@if (bp.importInfo.user) {
					von <strong>{{ bp.importInfo.user }}</strong>
				}
				@if (bp.importInfo.source) {
					aus <em>{{ bp.importInfo.source }}</em>
				}
				@if (bp.importInfo.coordTransform) {
					<br><small class="text-muted">Koordinaten: {{ bp.importInfo.coordTransform }}</small>
				}
			</span>
		</div>
	}

	<!-- Bereich 1: Fehlermeldungen und Warnungen (klappbar) -->
	<div class="plausi-section" *ngIf="vs.hasMessages()">
		<div class="section-header" (click)="messagesCollapsed = !messagesCollapsed">
			<i class="bi" [ngClass]="messagesCollapsed ? 'bi-chevron-right' : 'bi-chevron-down'"></i>
			<i class="bi bi-exclamation-triangle"></i>
			<span>Fehlermeldungen und Warnungen</span>
			<span class="badge bg-secondary ms-2">{{ (vs.danger_ | keyvalue).length + (vs.warning_ | keyvalue).length + (vs.message_ | keyvalue).length }}</span>
		</div>
		<div class="section-content" [ngClass]="{ 'collapsed': messagesCollapsed }">
			<!-- Fehler (danger) -->
			<div class="plausi-item danger" *ngFor="let e of vs.danger_ | keyvalue">
				<div class="item-icon"><i class="bi bi-x-circle-fill"></i></div>
				<div class="item-label">{{displayString(e.key)}}</div>
				<div class="item-message">{{e.value}}</div>
			</div>
			<!-- Warnungen -->
			<div class="plausi-item warning" *ngFor="let e of vs.warning_ | keyvalue">
				<div class="item-icon"><i class="bi bi-exclamation-triangle-fill"></i></div>
				<div class="item-label">{{displayString(e.key)}}</div>
				<div class="item-message">{{e.value}}</div>
			</div>
			<!-- Hinweise -->
			<div class="plausi-item info" *ngFor="let e of vs.message_ | keyvalue">
				<div class="item-icon"><i class="bi bi-info-circle-fill"></i></div>
				<div class="item-label">{{displayString(e.key)}}</div>
				<div class="item-message">{{e.value}}</div>
			</div>
		</div>
	</div>

	<!-- Bereich 2: Kommentare (klappbar) -->
	<div class="plausi-section" *ngIf="vs.hasCheckerComments()">
		<div class="section-header" (click)="commentsCollapsed = !commentsCollapsed">
			<i class="bi" [ngClass]="commentsCollapsed ? 'bi-chevron-right' : 'bi-chevron-down'"></i>
			<i class="bi bi-chat-left-text"></i>
			<span>Kommentare aus der Kontrolle</span>
			<span class="badge bg-secondary ms-2">{{ commentsCount }}</span>
		</div>
		<div class="section-content" [ngClass]="{ 'collapsed': commentsCollapsed }">
			<div class="comment-item" *ngFor="let e of vs.checkerComments() | keyvalue"
				[ngClass]="{ 'danger': e.value.type === ValRes.danger, 'warning': e.value.type === ValRes.warning, 'ok': e.value.type === ValRes.ok }">
				<div class="comment-header">
					<span class="comment-label">{{displayString(e.key)}}</span>
					<button class="btn btn-sm comment-btn" [ngClass]="commentsClass(e.value, 'btn-')" (click)="onCommentsClicked(e.key, e.value)">
						<i class="bi bi-chat-left-text"></i>
					</button>
				</div>
				<div class="comment-content">
					<wd-comments [name]="e.key" [comments]="e.value"></wd-comments>
				</div>
			</div>
		</div>
	</div>

	<!-- Keine Meldungen -->
	<div class="plausi-empty" *ngIf="!vs.hasAny()">
		<i class="bi bi-check-circle"></i>
		<span>Keine Meldungen oder Kommentare vorhanden.</span>
	</div>
</div>
